import React, { useEffect, useRef } from 'react';
import { defineCustomElements } from '@om-design-system/web-components/loader';

const OmLinearProgress = React.forwardRef(({
  value = 0,
  buffer = 0,
  max = 1,
  indeterminate = false,
  className,
  style,
  ...props
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    defineCustomElements();
  }, []);

  return (
    <omk-linear-progress
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      value={value}
      buffer={buffer}
      max={max}
      indeterminate={indeterminate}
      className={className}
      style={style}
      {...props}
    />
  );
});

OmLinearProgress.displayName = 'OmLinearProgress';

export default OmLinearProgress;
